export default "__VITE_ASSET__D2guz3Ug__"